import moment from 'moment';
import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { Navigate, useNavigate } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { cancelBooking, deleteBooking, getMyBooking } from '../../actions/booking';
import { getRooms } from '../../actions/room';

const Booking = ({auth: {isAuthenticated}, getMyBooking, booking: {bookings}, getRooms, room: {rooms}, cancelBooking, deleteBooking}) => {

  const navigate = useNavigate();

  useEffect(() => {
    getMyBooking();
  }, [getMyBooking])

  useEffect(() => {
    getRooms();
  }, [getRooms])

  if(!isAuthenticated) {
    return <Navigate to = '/homeScreen'/>
  }

  return (
    <div className="container">
      <h4><i className='fa-light fa-receipt' style={{color: 'var(--primary-color)'}} />&nbsp;Your Bookings</h4>
      {bookings.map((b) => (

        <div className='bs container' style={{ maxWidth: '90%'}} key={b._id}>
          
          <Row>
            <Col style={{padding: '10px'}}>
              {rooms.map(room => room._id === b.roomid && 
              <>
                <Row><img src={room.imageurl[0]} alt = 'room img' /></Row>
                <Row><Col>Room: {room.roomno}</Col><Col style={{textAlign: 'right'}}>Type: {room.roomtype}</Col></Row>
              </>
              )}
            </Col>
            <Col style={{padding: '10px'}}>
              <h6>Booking Details</h6>
              <Row><Col>Guest Name</Col><Col>{b.name}</Col></Row>
              <Row><Col>Mobile</Col><Col>{b.mobile}</Col></Row>
              <Row><Col>Duration</Col><Col>{b.totaldays}{' '}Days</Col></Row>
              <Row><Col>Check-In Date</Col><Col>{moment(b.datefrom, 'DD-MM-YYYY').format('DD MMM YYYY')}</Col></Row>
              <Row><Col>Check-Out Date</Col><Col>{moment(b.dateto, 'DD-MM-YYYY').format('DD MMM YYYY')}</Col></Row>
              <Row><Col>Coupon</Col><Col>{b.couponcode && <>{b.couponcode}</>} {!b.couponcode && <>Not Applied</>}</Col></Row>
              <Row><Col>Amount</Col><Col><b><i className='fa fa-indian-rupee'></i>&nbsp;{b.totalamount}</b></Col></Row>
            </Col>
            <Col style={{padding: '10px'}}>
              <h6>Booking Status</h6>
              <Row><Col>Status</Col>
                <Col>
                  {b.status === 'saved' && <h6 style={{color: 'var(--danger-color)', border:'dashed 1px var(--danger-color)'}}><center>Not Confirmed</center></h6>}
                  {b.status === 'cancelled' && <h6 style={{color: 'var(--primary-color)', border:'dashed 1px var(--primary-color)'}}><center>Cancelled</center></h6>}
                  {b.status === 'confirmed' && <h6 style={{color: 'var(--success-color)', border: 'dashed 1px var(--success-color)'}}><center>Confirmed</center></h6>}
                </Col>
              </Row>
              { b.status === 'saved' &&
              <>
              <Row>
                <Col style={{color: 'var(--primary-color)'}}><u style={{cursor:'pointer'}} onClick={() => cancelBooking(b._id, navigate)}>Cancel</u></Col>
                <Col style={{color: 'var(--danger-color)'}}><u style={{cursor:'pointer'}} onClick={() => deleteBooking(b._id, navigate)}>Delete</u></Col>
              </Row>
              <Row style={{marginTop: '10px'}}>
                  <Col>Pay to Confirm</Col>
                  <Col>
                    <LinkContainer to={`/pay/${b._id}/${b.totalamount}`}>
                      <button className='btn btn-outline-success'>Pay</button>
                    </LinkContainer>
                    </Col>
                  {/* <Col><button className="btn btn-danger" style={{ "marginTop": "10px"}} onClick={() => checkoutHandler(b.totalamount)}>Pay</button></Col> */}
              </Row>
              </>
              }
              { b.status === 'confirmed' &&
              <>
                <Row><Col>Transaction Id</Col><Col>{b.transactionid ==='default' ? <>Not yet paid</> : <>{b.transactionid}</> }</Col></Row>
              </>
              }
            </Col>
          </Row>
        </div>

      ))}
  </div>
  )
};

Booking.propTypes = {
  auth: propTypes.object.isRequired,
  booking: propTypes.object.isRequired,
  getMyBooking: propTypes.func.isRequired,
  getRooms: propTypes.func.isRequired,
  room: propTypes.object.isRequired,
  cancelBooking: propTypes.func.isRequired,
  deleteBooking: propTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  booking: state.booking,
  room: state.room
});

export default connect(mapStateToProps, {getMyBooking, getRooms, cancelBooking, deleteBooking})(Booking);